import { render, staticRenderFns } from "./AllContactsDialog.vue?vue&type=template&id=16b5ddb9"
import script from "./AllContactsDialog.vue?vue&type=script&lang=js"
export * from "./AllContactsDialog.vue?vue&type=script&lang=js"
import style0 from "./AllContactsDialog.vue?vue&type=style&index=0&id=16b5ddb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports